module.exports = __webpack_public_path__ + "img/SMI.a867da47.png";